@if (authService.hasPermission(Permission.EnhancementVariantsFull) && displayMode === 'icon') {
  <button
    mat-icon-button
    class="apply-enhancement"
    [disabled]="!product.masterSuiteId"
    matTooltip="Change Enhancement Variant"
    (click)="onChangeEnhancementVariant()"
    >
    @if (enhancementVariantIdSelected) {
      <mat-icon>auto_fix_high</mat-icon>
    } @else {
      <mat-icon matBadge="i" matBadgeSize="small">auto_fix_high</mat-icon>
    }
  </button>
}

@if (authService.hasPermission(Permission.EnhancementVariantsFull) && displayMode === 'menu-item') {
  <button
    mat-menu-item
    [disabled]="!product.masterSuiteId"
    (click)="onChangeEnhancementVariant()"
    >
    <mat-icon>auto_fix_high</mat-icon>
    <span>Change Enhancement Variant</span>
  </button>
}
